<template>
  <section class="shield-home s-contact">
    <ShieldHeader />

    <div class="container-wide">
      <div class="content">
        <ShieldNavigation />

        <div class="banner">
          
          <picture>
            <source
              media="(max-width: 480px)"
              srcset="../assets/shield-banners/shield-bios-banner-03-square.jpg"
              alt=""
            />
            <source
              media="(min-width:481px)"
              srcset="../assets/shield-banners/shield-bios-banner-03.jpg"
              alt=""
            />
            <img
              src="../assets/shield-banners/shield-bios-banner-03.jpg"
              alt=""
            />
          </picture>
        </div>

        <div class="copy">
          <h2>Contact Us</h2>
          <p>
            Please fill out the fields below for the project you need help with
            and we will be in touch with you as soon as we have had a chance to
            review your information. For immediate help call our main number at
            <a href="tel:+18177580470" class="telephone-link">(817) 754-0470</a>
            or Jacob on his cell phone at
            <a href="tel:+18174015990" class="telephone-link">(817) 401-5990</a
            >.
          </p>
          
          <form class="shield-form" action="https://www.elformo.com/forms/98d0c0c9-0641-4221-b1ad-ef5ba7450e7f" method="post" accept-charset="UTF-8">
            
            <input id="elformo_honeypot" name="elformo_honeypot" />
            <div class="input-group">
              <label for="lblContactName">name</label>
              <input type="text" name="requester" />
            </div>

            <div class="input-group">
              <label for="lblAddress">address</label>
              <input type="text" name="address" />
            </div>

            <div class="input-group">
              <label for="lblCityStateZip">city/state/zip</label>
              <input type="text" name="cityStateZip" />
            </div>

            <div class="input-group">
              <label for="lblcell">cell phone</label>
              <input type="tel" name="cell" />
            </div>

            <div class="input-group">
              <label for="lblQuestion">question</label>
              <textarea name="question" cols="30" rows="10" ></textarea>
            </div>

            <div class="form-submit">
              <button type="submit" class="btn-primary">Contact Us</button>
            </div>


          </form>
        </div>
      </div>
    </div>

    <ShieldFooter />
  </section>
</template>

<script>
import ShieldHeader from "@/components/ShieldHeader.vue";
import ShieldNavigation from "@/components/ShieldNavigation.vue";
import ShieldFooter from "@/components/ShieldFooter.vue";

export default {
  name: "ShieldHome",
  components: {
    ShieldHeader,
    ShieldNavigation,
    ShieldFooter
  }
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";

#elformo_honeypot {
  display: none;
}

.content {
  background: #fff;
  min-height: 50vh;
}

.section-link {
  text-decoration: none;
}

.section-link:link,
.section-link:visited {
  color: #444;
}

a.telephone-link {
        text-decoration:none;
        color:#aa6b2c;

    @media screen and (max-width:$small-bp){
        border-bottom:1px dotted #aa6b2c;
    } 
}

.form-message {
 margin-top:1em;
 padding:0.3em;
 background:lighten(#aa6b2c,30%);
 border:3px solid #aa6b2c;
 border-radius: 1em;
 color: #000;
}

@keyframes formSuccess {
  0% {
    opacity:0;
  }
  10% {
    opacity:1;
  }
  90% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

</style>
